export default {
      id: "ic-misc-paperplane-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-paperplane-usage",
      toString: function () {
        return this.url;
      }
    }